import { FontConfig } from "../types"

export const HEADING_4_CONFIG: FontConfig = {
  title: "Headings/h4",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 18, tw: "text-[18px]" },
    lineHeight: { px: 27, tw: "leading-[27px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 28, tw: "text-[28px]" },
    lineHeight: { px: 42, tw: "leading-[42px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 38, tw: "text-[38px]" },
    lineHeight: { px: 57, tw: "leading-[57px]" },
  },
}
